import React, { PropsWithChildren } from 'react'
import Button from '@Components/Buttons/Button'
import './index.scss'

interface HeaderInfoBoxProps {
    imageType: string
    heading: string
    buttonText?: string
    buttonLink?: string
    isButton?: boolean
    btnClassName?: string
    onClick?: () => void
}
const HeaderInfoBox = (props: PropsWithChildren<HeaderInfoBoxProps>) => {
    const { imageType, onClick, heading, buttonText, buttonLink, btnClassName, children, isButton } = props

    return (
        <>
            <div className="header-info-box">
                <img className="help-image" src={imageType} alt="Help Box Image" />
                <h5>{heading}</h5>
                <div className="box-info-body">
                    <>{children}</>
                </div>
                {isButton && (
                    <Button
                        type="primary"
                        mainColor
                        linkTo={buttonLink}
                        typeLink={!!buttonLink}
                        className={btnClassName}
                        onClick={onClick}
                        target="_blank"
                    >
                        {buttonText}
                    </Button>
                )}
            </div>
        </>
    )
}

export default HeaderInfoBox
